<template>
  <v-row>
    <v-col cols="12">
      <autoupdate-manage />
    </v-col>
    <v-col cols="12">
      <autoupdate-list />
    </v-col>
  </v-row>
</template>

<script>
import AutoupdateList from '@/components/Services/Hosting/Shared/Wordpress/Autoupdate/AutoupdateList'
import AutoupdateManage from '@/components/Services/Hosting/Shared/Wordpress/Autoupdate/AutoupdateManage'

export default {
  name: 'AutoupdateView',
  components: {
    AutoupdateList,
    AutoupdateManage,
  },
}
</script>
